import { render, staticRenderFns } from "./Linkedin.vue?vue&type=template&id=38fc2a32"
import script from "./Linkedin.vue?vue&type=script&lang=ts"
export * from "./Linkedin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports